import { getAccessToken } from './auth';

function getUrl(endpoint: string) {
  return `${import.meta.env.VITE_REST_GATEWAY_API_URL}/${endpoint}`;
}

function getAuthHeaders() {
  return {
    Authorization: `Bearer ${getAccessToken()}`,
  };
}

async function upload(endpoint: string, file: File): Promise<UploadResponse> {
  const formData = new FormData();
  formData.append('file', file);

  try {
    const response = await fetch(getUrl(endpoint), {
      method: 'POST',
      headers: getAuthHeaders(),
      body: formData,
    });

    const responseJson = await response.json();

    return response.ok ? { error: null } : { error: responseJson };
  } catch (error) {
    return { error: String(error) };
  }
}

export type UploadResponse = {
  error: null | { error: string; message: string } | any;
};

export const uploadService = {
  upload,
};

export const downloadFileFromUrl = async (
  url: string,
  filename: string,
  onSuccess?: () => void,
  onError?: (error: Error) => void,
) => {
  try {
    const response = await fetch(url, { method: 'GET' });

    if (!response.ok) throw new Error('Failed to fetch file');

    const blob = await response.blob();
    const downloadUrl = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();

    window.URL.revokeObjectURL(downloadUrl);
    onSuccess?.();
  } catch (error) {
    onError?.(error as Error);
  }
};
